<template>
	<section>
		<home-search @start-search="$emit('start-search')"></home-search>
		<!-- <eventos-destacados></eventos-destacados> -->
		<eventos-home></eventos-home>
		<!-- <home-estadisticas></home-estadisticas> -->
		<!-- <div class="lineup-infinite">
			<div class="marquee--inner">
				<span>
					LineUp Tickets. Be There. LineUp Tickets. Be There. LineUp Tickets. Be There. LineUp Tickets. Be There. LineUp Tickets. Be There.
				</span>
				<span>
					LineUp Tickets. Be There. LineUp Tickets. Be There. LineUp Tickets. Be There. LineUp Tickets. Be There. LineUp Tickets. Be There.
				</span>
			</div>
		</div> -->
		<quiero-mi-evento></quiero-mi-evento>
		<modal name="welcome-modal" class="welcome-modal" transition="scale">
			<div class="welcome-modal-close" @click="$modal.hide('welcome-modal')">
				<i class='bx bx-x'></i>
			</div>
			<div class="welcome-modal-content">
				<div class="welcome-left">
					<img src="../assets/ticketin/Defecto.svg" alt="">
				</div>
				<div class="welcome-right">
					<h2>¡Bienvenido!</h2>
					<p>Tu cuenta fue creada exitosamente. El equipo de LineUp Tickets te da la bienvenida al sitio. </p>
				</div>
			</div>
		</modal>
	</section>
</template>

<script>
	import HomeSearch from "./../components/HomeSearch.vue";
	import EventosHome from "./../components/eventos/EventosHome.vue";
	import QuieroMiEvento from './../components/QuieroMiEvento.vue';

	export default {
		props: ['isWelcome'],
		components: {
			HomeSearch,
			EventosHome,
			QuieroMiEvento
		},
		metaInfo: {
			title: 'Tu boleto de entrada a los eventos más emocionantes',
			titleTemplate: 'LineUp Tickets 🎟 %s'
		},
		mounted() {
			this.$store.dispatch('setFromStateSocial', '/');

			// if(this.isWelcome === true){
			// 	this.$modal.show('welcome-modal')
			// }

			this.$store.dispatch("AuthModule/updateCallbackAction", {
				callbackAction: {
					name: "AuthModule/redirigirA",
					payload: {
						route: "home",
						params: {},
					},
				},
			});
		},
	};
</script>

<style lang="scss" scoped>
	.lineup-infinite {
		// width: 100%;
		// padding: 0px;
		// white-space: nowrap;
		// overflow: hidden;
		// @include flex(row, flex-start, center);
		// background-color: var(--color-primary);

		// marquee {
		// 	font-family: var(--font-sora);
		// 	font-size: 32px;
		// 	font-weight: var(--fw-700);
		// 	line-height: 1.4em;
		// 	text-indent: -100%;
		// 	color: var(--color-darker);
		// 	padding: 8px 0px;
		// 	user-select: none;
		// }

		width: 100%;
		height: 60px;
		overflow: hidden;
		position: relative;
		padding: 0;
		background-color: var(--color-primary);
		@include flex(row, center, center);

		.marquee--inner{
			@include flex(row, flex-start, center);
			width: 200%;
			position: absolute;
			animation: marquee 10s linear infinite;

			span{
				float: left;
				width: 50%;
				white-space: nowrap;
				overflow: hidden;
				font-family: var(--font-sora);
				font-size: 32px;
				font-weight: var(--fw-700);
				line-height: 1.4em;
				color: var(--color-darker);
				padding: 8px;
				user-select: none;
				// background: red;
			}
		}
	}

	@keyframes marquee {
		0% {
			left: 0;
		}
		100% {
			left: -100%;
		}
	}
</style>
